<template>
  <v-app-bar
    app
    dense
  >
    <v-container
      grid-list-xs
      fill-height
    >
      <v-row align="center">
        <h2>
          <router-link
            class="black--text"
            style="text-decoration: none;"
            to="/"
          >
            DataX, LTD
          </router-link>
        </h2>

        <v-toolbar-title :style="titleStyles">
          <h1 :class="titleClasses">
            <router-link
              class="black--text"
              style="text-decoration: none;"
              to="/"
            >
              Consumer Freeze Online Portal
            </router-link>
          </h1>
        </v-toolbar-title>

        <locale-switcher />
        <user-profile />
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import LocaleSwitcher from '@/components/LocaleSwitcher.vue';
import UserProfile from '@/components/UserProfile.vue';

export default {
  name: 'Toolbar',
  components: {
    LocaleSwitcher,
    UserProfile,
  },
  computed: {
    titleClasses() {
      return (this.$vuetify.display.mdAndUp && 'display-1') || (this.$vuetify.display.smAndUp && 'headline') || 'title';
    },
    logoWidth() {
      return (this.$vuetify.display.mdAndUp && 180) || (this.$vuetify.display.smAndUp && 100) || 60;
    },
    titleStyles() {
      return { 'text-align': 'center'};
    },
  },
};
</script>

<style lang="scss">
  header {
    .v-toolbar__content {
      padding-left: 0;
      padding-right: 0;
    }
  }

  .black--text {
    color: #000 !important;
  }

  @supports (-ms-ime-align:auto) {
    .logo {
      height: 50px;
    }
  }
</style>
